
import { getSignedUrlForS3 } from '../api/s3_file_api';

export const openS3File = async (s3Key) => {
    try {
        if (!s3Key) {
            alert('לא ניתן לפתוח את הקובץ: מפתח לא קיים');
            return;
        }
        const url = await getSignedUrlForS3(s3Key);
        if (!url) {
            alert('שגיאה בפתיחת קובץ: לא ניתן לקבל כתובת URL');
            return;
        }
        window.open(url, '_blank');
    } catch (err) {
        console.error('Error opening S3 file:', err);
        alert('שגיאה בפתיחת הקובץ');
    }
};
